import { EventHandler, FormEvent, MouseEvent, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { useAuth } from "../signin/auth";
import { getChecklist, writeChecklistItem } from "./checklistSlice";

interface ChecklistItemInputProps {
  checklistID: string
}

function ChecklistItemInput(props: ChecklistItemInputProps) {
  const { checklistID } = props;
  const [name, setName] = useState<string>('');
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();


  const onSubmit: EventHandler<FormEvent<HTMLFormElement> | MouseEvent<HTMLButtonElement>> = async (evt) => {
    evt.preventDefault();
    setName('');
    if (auth.authToken) {
      await dispatch(writeChecklistItem({
        authToken: auth.authToken,
        checklistItem: {
          name: name,
          completedOn: null,
          checklistID: checklistID,
          order: 0,
        }
      }));
      dispatch(getChecklist({
        authToken: auth.authToken,
        checklistID: checklistID,
        includeItems: true,
      }))
    } else {
      console.log('No auth token!')
    }
  }

  return (
    <Form onSubmit={onSubmit}>
      <InputGroup>
        <Form.Control placeholder="Item text" value={name} onChange={(e) => setName(e.target.value)} />
        <Button onClick={onSubmit} variant="outline-primary">Add checklist item</Button>
      </InputGroup>
    </Form>
  )
}

export default ChecklistItemInput